<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"direction:ltr"' class="text-center my-5 " >
                <template #default>Not found.   </template>
                </m-h1><m-h4 v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>404   </template>
                </m-h4><m-lottie-1 v-bind='{...{"animationLink":"https:\/\/api.pamenarvillage.ir\/api\/cors\/assets\/3.json","height":500,"width":700},...{}}' :style='""' class="" ></m-lottie-1></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mLottie1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Lottie/Lottie1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mH4,mLottie1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
